export default {
  not_set_up: {
    title: 'Reservationer er endnu ikke konfigureret for denne lokation',
    description:
      'En lokation får reservationer, når den er forbundet til sin Google-opslag og har en ejer. Hvis restauranten endnu ikke har en ejer, skal du tilføje en under Team. Indtil da er der ingen åbningstider for reservationer at redigere her, og ændringer i Online Shop-åbningstider kopieres ikke til Reservationer.',
  },
  company_not_loaded: {
    title: 'Reservationsindstillinger kunne ikke indlæses',
    description:
      'Denne lokations reservationsindstillinger kunne ikke indlæses, så dens åbningstider for reservationer kan ikke redigeres lige nu. Prøv igen.',
    retry: 'Prøv igen',
  },
};
